import React, { FC } from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import styles from 'features/build-your-own/components/BYOItemTile/components/ItemFeatureDetails.module.scss';
import { FeatureSection } from 'api/contentful/contentTypes.cloverdotcom';
import { ItemFeatureDetail } from './ItemFeatureDetail';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { FlatEntry } from 'services/cms/flattenContentful';

interface ItemFeatureDetailsProp {
  features?: FlatEntry<FeatureSection>[];
}

export const ItemFeatureDetails: FC<ItemFeatureDetailsProp> = ({ features }) => {
  if (!features) return null;

  return (
    <div className={styles.container}>
      {features.map((feature, index) => (
        <div key={componentKeyV2(feature, index)}>
          <TextV2 isMarkdown tagName="small" value={feature.title} className={styles.title} />
          <ItemFeatureDetail features={feature.includedFeatures} />
        </div>
      ))}
    </div>
  );
};
